export const Button = 'button'
export const Col = 'col'
export const ColGroup = 'colgroup'
export const Div = 'div'
export const H1 = 'h1'
export const Input = 'input'
export const Kbd = 'kbd'
export const Span = 'span'
export const Table = 'table'
export const TBody = 'tbody'
export const Td = 'td'
export const Th = 'th'
export const THead = 'thead'
export const Tr = 'tr'
export const I = 'i'
export const Img = 'img'
export const Ins = 'ins'
export const Del = 'del'
